<template>
  <button
    class="SeasonRunButton"
    type="button"
    :class="{
      'SeasonRunButton--isActive': !isPast && !isLocked && !run.canceled_at,
      'SeasonRunButton--isPast': isPast,
      'SeasonRunButton--isLocked': isLocked,
      'SeasonRunButton--isCanceled': !!run.canceled_at,
    }"
    :aria-label="`View run on ${formattedDate}`"
  >
    <span class="SeasonRunButton__label">&nbsp;{{ formattedDate }}&nbsp;</span>
  </button>
</template>

<script lang="ts" setup>
import useNow from "@/composables/useNow";
import { Run } from "@shared/lib/database/query.types";
import { format, isBefore, parseISO, startOfDay } from "date-fns";
import { computed } from "vue";

const {
  run,
} = defineProps<{
  run: Run,
}>();

const {
  now,
} = useNow();

const formattedDate = computed(() => format(parseISO(run.start_at), "M'/'d"));
const isPast = computed(() => isBefore(startOfDay(parseISO(run.start_at)), startOfDay(now.value)));
const isLocked = computed(() => run.rsvp_at && isBefore(now.value, parseISO(run.rsvp_at)));
</script>

<style lang="scss" scoped>
.SeasonRunButton {
  display: grid;
  place-items: center;
  width: 100%;
  height: 44px;
  padding: var(--fontSafariOffset) 0 0;

  border: solid 2px var(--themeColorNeutral900);
  border-radius: 4px;

  font-family: var(--fontFamilyMono);
  font-size: 16px;
  font-weight: var(--fontWeightMedium);
  white-space: nowrap;

  &.SeasonRunButton--isPast:not(.SeasonRunButton--isCanceled) {
    background-color: var(--themeColorNeutral200);
    color: var(--themeColorNeutral900);
  }

  &.SeasonRunButton--isActive {
    background-color: var(--themeColorSecondary);
    color: var(--themeColorSecondaryForeground);
  }

  &.SeasonRunButton--isCanceled {
    border-color: var(--themeColorNeutral400);
  }
}

.SeasonRunButton__label {
  .SeasonRunButton--isCanceled & {
    color: var(--themeColorNeutral400);

    text-decoration: line-through;
    text-decoration-color: currentColor;
    text-decoration-thickness: 2px;
  }
}
</style>
